export default __webpack_public_path__ + "static/media/left6.d211a355.png";